import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { AppErrorBoundary } from "./app/RouteErrorBoundary";
import { registerServiceWorker } from "./pwa/register";
import "./styles/globals.css";

// Fire and forget: a browser without service workers, or a build without the
// plugin, must still start normally. Nothing in the app waits on this.
void registerServiceWorker().catch(() => {
  // An unregistrable worker means no offline support, which is a smaller
  // problem than a blank page.
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
